import { MessageType } from '../enum';
import {
  FieldValueEditedType,
  UpdateForm,
  MeasureValueEditedType,
  Message,
  NotificationType,
  UpdateSubform,
} from '../model';

export function isNotificationMessage(message: Message): message is NotificationType {
  return message && message.messageType === MessageType.NOTIFICATION;
}

export function isMeasureValueEditedMessage(message: Message): message is MeasureValueEditedType {
  return message && message.messageType === MessageType.MEASURE_VALUE_EDITED;
}

export function isFieldValueEditedMessage(message: Message): message is FieldValueEditedType {
  return message && message.messageType === MessageType.FIELD_VALUE_EDITED;
}

export function isUpdateForm(message: Message): message is UpdateForm {
  return message && message.messageType === MessageType.UPDATE_FORM;
}

export function isUpdateSubform(message: Message): message is UpdateSubform {
  return message && message.messageType === MessageType.UPDATE_SUBFORM;
}
